import React from 'react';
import { NavLink } from 'react-router-dom';
import iconDashboard from '../../images/icon-dashboard.svg'; 
import iconUsers from '../../images/icon-users.svg'; 
import iconNutrition from '../../images/icon-nutrition.svg'; 
import iconTraining from '../../images/icon-training.svg'; 
import iconVideos from '../../images/icon-videos.svg'; 
import iconConfiguration from '../../images/icon-configuration.svg'; 

const NavMenu = () => {
  
  const shouldHideDashboard = (localStorage.getItem("486478dh784dh4dh4d4h64nngx4c5v6bnyx7xnnvxsrdese") == "1" && localStorage.getItem("userId") != "1211");

  const navItems = [
    shouldHideDashboard && { to: "/admin/dashboard", imgSrc: iconDashboard, alt: "Dashboard", label: "Dashboard" },
    { to: "/admin/users", imgSrc: iconUsers, alt: "Users", label: "Users" },
    { to: "/admin/nutrition", imgSrc: iconNutrition, alt: "Nutrition", label: "Nutrition" },
    { to: "/admin/training", imgSrc: iconTraining, alt: "Training", label: "Training" },
    { to: "/admin/videos", imgSrc: iconVideos, alt: "Videos" },
    { to: "/admin/configuration", imgSrc: iconConfiguration, alt: "Configuration" },
  ].filter(Boolean); // Remove falsy values from the array

  return (
    <ul className="ul-nav">
      {navItems.map((item, index) => (
        <li key={index}>
          <NavLink to={item.to} activeClassName="active">
            <img src={item.imgSrc} alt={item.alt} />
            <span>{item.label}</span>
          </NavLink>
        </li>
      ))}
    </ul>
  );
};

export default NavMenu;
